/* eslint-disable */
import { useParameter, useExport, useDictionary } from "../../../shared";
import * as React from "react";
import { REPORT_ID, SLIDE_NUMBER } from "../constants";
import { dictionaryService } from "../../../dataFlow";

export function useExportQuery(title, subtitle) {
  const exportBuilder = useExport();
  const [calendar] = useParameter<number[]>("@calendar");
  const [sources] = useParameter<string[]>("@sources");
  const [commodities] = useParameter<number>("@commodities");
  const [commoditiesDisplay] = useParameter<number>("@commodities_display");

  const [dictItems] = useDictionary(dictionaryService, "commodities_slide_31_32", undefined, {
    olap_commodity: commodities,
    slide: SLIDE_NUMBER,
  });

  React.useEffect(() => {
    const historicalSources = dictItems
      ?.filter(e => e.getValue("comment") === "historical")
      .map(e => e.getValue("source"))
    || [];

    exportBuilder.set('title', title);
    exportBuilder.set('subtitle', subtitle);
    exportBuilder.set('reportDefinition', {
      reportId: exportBuilder.reportId,
      name: { 9: title },
      parameters: {
        "@calendar": calendar,
        "@commodities": commodities,
        "@commodities_display": commoditiesDisplay,
        "@sources": [...historicalSources, ...(sources || [])],
      }
    });
  }, [title, subtitle, exportBuilder, calendar, commodities, commoditiesDisplay, sources, dictItems]);
}

